var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBagDistribution(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.5L6.84 10.28C6.46 9.62 6.95 8.79 7.71 8.79H13.29C14.05 8.79 14.54 9.62 14.16 10.28L12.75 12.5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.45 13C12.46 13.01 12.47 13.02 12.48 13.03C12.6 13.16 12.77 13.34 12.96 13.57C13.36 14.04 13.89 14.69 14.42 15.44C14.96 16.19 15.48 17.03 15.87 17.88C16.26 18.73 16.5 19.55 16.5 20.26C16.5 21.22 16.15 22.12 15.27 22.8C14.38 23.49 12.88 24 10.5 24C8.12 24 6.62 23.49 5.73 22.8C4.85 22.12 4.5 21.22 4.5 20.26C4.5 19.55 4.74 18.73 5.13 17.88C5.52 17.03 6.04 16.19 6.58 15.44C7.11 14.69 7.64 14.04 8.04 13.57C8.23 13.34 8.4 13.16 8.52 13.03C8.53 13.02 8.54 13.01 8.55 13H12.45Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17H26.5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12L27 17L22 22",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagDistribution);
export default __webpack_public_path__ + "static/media/BagDistribution.855bd075.svg";
export { ForwardRef as ReactComponent };